import requestV2 from '@/service/request-v2'
import { normalizePageResult } from '@/service/adapters/page-result'
import type { PageQuery, PageResult } from '@/types/crud'

export interface StatisticalContinueFilters {
  channelId: string | number
  accessTime: string[]
  continueAttend: string
  deptId: string | number
  empIds: string | number
}

export interface StatisticalContinueRecord {
  id?: string | number
  consumerNickName: string
  consumerHeadImgUrl: string
  channelName: string
  deptName: string
  empName: string
}

interface EmployeeRecord {
  id: string | number
  realName: string
}

interface ChannelRecord {
  rowId: string | number
  eventName: string
}

export interface StatisticalContinueFilterOptions {
  employees: EmployeeRecord[]
  channels: ChannelRecord[]
}

function requireArray<T>(payload: unknown, label: string): T[] {
  if (!Array.isArray(payload)) throw new Error(`${label}响应必须是数组`)
  return payload as T[]
}

export async function fetchStatisticalContinuePage(
  query: PageQuery<StatisticalContinueFilters>,
  signal: AbortSignal
): Promise<PageResult<StatisticalContinueRecord>> {
  const payload = await requestV2.get<unknown>({
    url: '/main/liveStatisticalContinue/queryByCondition',
    params: {
      ...query.filters,
      pageNo: query.pageNo,
      pageSize: query.pageSize
    },
    signal
  })
  return normalizePageResult<StatisticalContinueRecord>(payload)
}

export async function fetchStatisticalContinueFilterOptions(): Promise<StatisticalContinueFilterOptions> {
  const [employeePayload, channelPayload] = await Promise.all([
    requestV2.get<unknown>({
      url: '/main/employee/queryEmpList'
    }),
    requestV2.get<unknown>({
      url: '/main/customerEvents/queryByCondition',
      params: {
        pageNo: 1,
        pageSize: 1000
      }
    })
  ])

  return {
    employees: requireArray<EmployeeRecord>(employeePayload, '员工列表'),
    channels: normalizePageResult<ChannelRecord>(channelPayload).records
  }
}
